import { combineReducers } from 'redux';
import { generate } from 'shortid'; // import { INICIALIZAR } from '../../actions'

import { SESION_ACTIVAR, SESION_CREAR, SESION_ELIMINAR, SESIONES_INICIALIZAR } from '../actions';
import * as Util from '../../util'; // function getSesionesFromStorage() {
//     // const key = action.config.configGeneral.key
//     window.console.log("getSesionesFromStorage -> Util.getStorageData(`sesiones`)")
//     const sesiones = Util.getStorageData(`sesiones`)
//     // const sesiones = (async () => await Util.getStorageData(`sesiones`))()
//     window.console.log("getSesionesFromStorage listo", {sesiones})
//     return sesiones || []
// }
// function getIdUltimaSesionActivaFromStorage() {
//     return Util.getStorageData('idUltimaSesionActiva') || null
// }

function sesiones() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case SESIONES_INICIALIZAR:
      return action.sesiones;
    // return getSesionesFromStorage(state, action)

    case SESION_CREAR:
      {
        var sesion = {
          id: generate(),
          fecha: Date.now(),
          nombre: action.nombre
        };
        return state ? [].concat(state, [sesion]) : [sesion];
      }

    case SESION_ELIMINAR:
      return [].concat(state.filter(function (sesion) {
        return sesion.id !== action.id;
      }));

    default:
      return state;
  }
}

function idSesionActiva() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    // case SESIONES_INICIALIZAR:
    //     return action.idUltimaSesionActiva
    case SESION_ACTIVAR:
      Util.setStorageData('idUltimaSesionActiva', action.id);
      Util.setKeyStorageSesion(action.id);
      return action.id;

    default:
      return state;
  }
}

function idUltimaSesionActiva() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments[1];

  switch (action.type) {
    case SESIONES_INICIALIZAR:
      return action.idUltimaSesionActiva;

    case SESION_ACTIVAR:
      return action.id;

    default:
      return state;
  }
}

export default combineReducers({
  sesiones: sesiones,
  idSesionActiva: idSesionActiva,
  idUltimaSesionActiva: idUltimaSesionActiva
});